import React, { Component } from "react";
import { branch, root } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";
import autoBind from "react-autobind";
import { Button, FormControl } from "react-bootstrap";

import { Page } from "../shared/";
import DriveWrapper from "./driveWrapper";
import browserHistory from "../../history";
import { handlePageInit } from "../../utils/securityUtil";
import state from "../../state/state";
import {
	ICH_ORG_ID,
	getSkuPhotoMappingActivityCandidates,
	getSkuPhotoMappingLaunchPath,
	resolveSkuPhotoMappingActivity
} from "../player/skuPhotoMappingMode";
// import { handleSave } from "../../actions/drive";

class DrivePage extends Component {

	constructor(props) {
		super(props);
		handlePageInit(this.props.location, false, true);
		this.state = {
			showModal: false,
			skuPhotoMappingActivityId: ""
		};
		autoBind(this);
	}

	handleOpenSkuPhotoMappingWorkbench() {
		const activity = resolveSkuPhotoMappingActivity(
			this.props.activities,
			this.state.skuPhotoMappingActivityId
		);
		if (activity && activity.id) {
			browserHistory.push(getSkuPhotoMappingLaunchPath(activity.id));
		}
	}

	handleSkuPhotoMappingActivityChange(event) {
		this.setState({ skuPhotoMappingActivityId: event.target.value });
	}

	render() {
		const { showModal } = this.state;
		const skuPhotoMappingAvailable = this.props.selectedOrgId === ICH_ORG_ID;
		const skuPhotoMappingActivities = skuPhotoMappingAvailable
			? getSkuPhotoMappingActivityCandidates(this.props.activities)
			: [];
		const skuPhotoMappingActivity = resolveSkuPhotoMappingActivity(
			skuPhotoMappingActivities,
			this.state.skuPhotoMappingActivityId
		);
		return (
			<Page title="Drive" subTitle="Manage organization files" showSaveModal={showModal} flexLayout>
				{skuPhotoMappingAvailable && <div style={{ flex: "0 0 auto", display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", borderBottom: "1px solid #d8dee4", backgroundColor: "#f5f8fb" }}>
					<div style={{ minWidth: 0 }}>
						<div style={{ fontWeight: 700 }}>SKU Photo Mapping</div>
						<div style={{ color: "#5f6b76", fontSize: 12 }}>
							{skuPhotoMappingActivity
								? "Use the Structural Selection outline and price-list records to link Drive photos to canonical SKUs."
								: "Import a tagged ICH Structural Selection activity to enable the workbench."}
						</div>
					</div>
					{skuPhotoMappingActivities.length > 1 && <FormControl
						componentClass="select"
						value={skuPhotoMappingActivity ? skuPhotoMappingActivity.id : ""}
						onChange={this.handleSkuPhotoMappingActivityChange}
						style={{ marginLeft: "auto", maxWidth: 300 }}>
						{skuPhotoMappingActivities.map((activity) => <option key={activity.id} value={activity.id}>
							{activity.name || activity.title || activity.id}
						</option>)}
					</FormControl>}
					{skuPhotoMappingActivities.length === 1 && <span style={{ marginLeft: "auto", color: "#5f6b76", fontSize: 12, whiteSpace: "nowrap" }}>
						{skuPhotoMappingActivity.name || skuPhotoMappingActivity.title || "Structural Selection"}
					</span>}
					<Button bsStyle="primary" style={{ whiteSpace: "nowrap" }} onClick={this.handleOpenSkuPhotoMappingWorkbench} disabled={!skuPhotoMappingActivity}>
						Open workbench
					</Button>
				</div>}
				<div style={{ flex: 1, flexGrow: 1, overflow: "hidden" }}>
					<DriveWrapper edit={true} />
				</div>
			</Page>
		);
	}
	componentDidMount() {
		this.context.tree.select(["appState", "navPanel"]).set("selected", "drive");
	}
}

DrivePage.contextTypes = {
	tree: PropTypes.baobab
};

export default root(state, branch({
	hierarchy: ["drive", "hierarchy"],
	selectedOrgId: ["selectedOrg", "id"],
	activities: ["activities"]
}, DrivePage));
